import axios from "axios";

const FetchUserRole = async searches => (
	await axios.get('/manage/users/roles')
);

export { FetchUserRole } ;
